import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectOption } from '../../../Interfaces/PIMs';
import {
  TicketQuestion,
  TicketResponses,
} from '../../../Interfaces/PIMs/Chat/TicketPIM';

interface InitialState {
  selectedTicket: TicketQuestion | null;
  ticketStatus: SelectOption[];
  selectedStatus: SelectOption;
  selectedResponse: TicketResponses;
}

const ticketInitialState: InitialState = {
  selectedTicket: null,
  ticketStatus: [
    { value: 'isOpen', label: 'Open' },
    { value: 'inProgress', label: 'In Progress' },
    { value: 'isClosed', label: 'Closed' },
    { value: 'isPending', label: 'Pending' },
    { value: 'isMerged', label: 'Merged' },
    { value: 'inQueue', label: 'In Queue' },
    { value: 'all', label: 'All' },
  ],
  selectedStatus: { label: 'All', value: 'all' },
  selectedResponse: {},
};

const ticketSlice = createSlice({
  name: 'SupportTicket',
  initialState: ticketInitialState,
  reducers: {
    upsertTicketResponse: (state, action: PayloadAction<TicketResponses>) => {
      state.selectedResponse = action.payload;
    },
    setSelectedTicket: (
      state,
      action: PayloadAction<TicketQuestion | null>
    ) => {
      state.selectedTicket = action.payload;
    },
    setSelectedStatus: (state, action: PayloadAction<SelectOption>) => {
      state.selectedStatus = action.payload;
    },
  },
});

export const { setSelectedTicket, upsertTicketResponse, setSelectedStatus } =
  ticketSlice.actions;

export default ticketSlice.reducer;
